import React, { useState, useEffect } from 'react';
import {
  Container,
  Box,
  Typography,
  Paper,
  Tabs,
  Tab,
  Alert,
  CircularProgress,
  Grid,
  Stack
} from '@mui/material';
import AdminStats from './AdminStats';
import AdminActions from './AdminActions';
import UserManagement from './UserManagement';
import CourseManagement from './CourseManagement';
import PaymentManagement from './PaymentManagement';
import MemberManagement from './MemberManagement';
import MembershipManagement from './MembershipManagement';
import { useAdmin } from '../../contexts/AdminContext';

const Admin = () => {
  const [activeTab, setActiveTab] = useState(() => {
    const savedTab = localStorage.getItem('adminPageActiveTab');
    return savedTab ? parseInt(savedTab, 10) : 0;
  });
  const { 
    loading, 
    error, 
    stats,
    refreshData,
    clearError 
  } = useAdmin();

  useEffect(() => {
    refreshData();
  // eslint-disable-next-line react-hooks/exhaustive-deps
  }, []);

  const handleTabChange = (event, newValue) => {
    setActiveTab(newValue);
    localStorage.setItem('adminPageActiveTab', newValue.toString());
  };

  if (loading) {
    return (
      <Container maxWidth="xl">
        <Box sx={{ display: 'flex', justifyContent: 'center', mt: 4 }}>
          <CircularProgress />
        </Box>
      </Container>
    );
  }

  return (
    <Container maxWidth="xl">
      <Box sx={{ py: 4 }}>
        <Typography variant="h4" gutterBottom>
          Pannello Amministrazione
        </Typography>

        {error && (
          <Alert severity="error" sx={{ mb: 2 }} onClose={clearError}>
            {error}
          </Alert>
        )}

        <Grid container spacing={3} sx={{ mb: 3, justifyContent: 'center' }}>
          
            <AdminStats stats={stats} onStatClick={handleTabChange} />
        
        
            <Stack direction={{ xs: 'column', md: 'row' }} justifyContent='center' spacing={2}>
              <AdminActions />
            </Stack>
        
        </Grid>

        {/* Tabs */}
        <Paper sx={{ width: '100%', mt: 2, borderRadius: 3, boxShadow: 3 }}>
          <Tabs
            value={activeTab}
            onChange={handleTabChange}
            aria-label="admin tabs"
            variant="scrollable"
            scrollButtons="auto"
            sx={{ borderBottom: 1, borderColor: 'divider', px: 2 }}
          >
            <Tab label="Utenti" />
            <Tab label="Tesserati" />
            <Tab label="Campagne di Tesseramento" />
            <Tab label="Corsi" />
            <Tab label="Pagamenti Corsi" />
          </Tabs>

          <Box sx={{ p: { xs: 1, md: 3 }, background: '#fafbfc', borderRadius: 2 }}>
            {activeTab === 0 && <UserManagement />}
            {activeTab === 1 && <MemberManagement />}
            {activeTab === 2 && <MembershipManagement />}
            {activeTab === 3 && <CourseManagement />}
            {activeTab === 4 && <PaymentManagement />}
          </Box>
        </Paper>
      </Box>
    </Container>
  );
};

export default Admin; 